<template>
  <div class="sso-login">
    <el-dialog :title="$t('app.changeVerifyPhoneTitle')" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div class="sso-login-form">
        <el-form ref="ruleForm" label-width="100px">
          <el-form-item :label="$t('app.label')" prop="name">
            <el-input v-model="ruleForm.name" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item :label="$t('app.label')" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
            <el-button>{{ $t('app.auto_339_3c3af093') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">{{ $t('app.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { GetQueryString } from "@/util/util";
import { getBasicUrls } from "@/util/config";
import { setCookie, getCookie, delCookie } from "@/util/cookie";
import {
  SideBarMenu,
  CRM_MENU,
  CRM_CALLCENTER_INFO,
  CRM_All_CALLCENTER,
  CRM_FUNC_KEYS,
  CRM_NAVFUNC_KEYS,
  CRM_NAVFUNC_URLS,
  CRM_MENU_KEYS,
  CRM_MENU_REPORT,
  Master_Use_Callphone,
  CRM_SCHOOL_TYPE,
  SSO_CAMPUS_INFO,
  SSO_LOGIN_INFO,
  ACCOUNT_UPGRADE
} from "@/util/keys";
import { toDoLogin, queryUserNavAndFunc, getCampusIdentity } from "@/api/login";
import LoginUserHelper from "@/util/LoginUserHelper";
export default {
  name: 'ssoLogin',
  data() {
    return {
      loading: false,
      dialogVisible: false,
      IsUpdatepwd: this.props.IsUpdatepwd,
      liked: true,
      isStateNum: 1,
      count: 59,
      phone: "",
      phone2: "",
      objParm: {},
      paramsLogin: {},
      isShowOpen: false,
      layerTitle: this.$t('app.auto_60_6c08e91d'),
      okText: this.$t('app.auto_61_423ca5e1')
    }
  },
  props: {
    IsUpdatepwd: {

    },
    propsPhone: {

    },
    itemUserObj: {
      type: Object,
      default: {},
    },
    BindOrderList: {
      type: Object,
      default: {},
    }
  },
  mounted() {
    const { ssoToken, campusId } = GetQueryString();
    const params = {
      ssoToken: ssoToken || '',
      campusId: campusId || 0,
      type: 5
    }
    this.ToLogin(params)
  },
  methods: {
    // 发送验证码
    SendVerificationCode() {
      let params = {
        mobile: this.propsPhone ? this.propsPhone : this.phone,
      }
      getPhoneCode(params).then(res => {
        if (res.code === 0) {
          this.$message({
            message: this.$t('app.codeSentViewOnPhone'),
            type: 'success'
          });
          const timer = setInterval(() => {
            this.count = this.count--;
            this.disabled = true;
            this.liked = false;
            if (this.count === 0) {
              this.disabled = false;
              this.count = 59;
              this.liked = true;
            }
          }, 1000);
        } else {
          this.$message.error(this.$getCodeMessage(res.code, res.message, res.messageArgs));
        }
      })
    },
    submit(callback) {
      let params = {
        "phone": this.phone || this.itemUserObj.phone,                //类型：String  必有字段  备注：手机号
        "phoneCode": this.phoneCode,                //类型：String  必有字段  备注：验证码
        "userId": this.BindOrderList.userId || ""                //类型：Number  必有字段  备注：用户ID
      }
      checkPhoneCode(params).then(ret => {
        if (ret.code === 0) {
          this.$message({
            message: ret.message || this.$t('app.auto_62_efa11156'),
            type: 'success'
          });
          // callback(ret, this.props.modal.close);
        }
        else {
          this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || this.$t('message.verifyFailed'));
        }
      })
    },
    async onOk() {
      let { isStateNum, objParm, phone } = this || {};
      let obj = JSON.stringify(objParm) != '{}' || {}
      if ((obj && !objParm.phone && isStateNum == 1)) {
        this.$message.error(this.$t('app.pleaseEnterOriginalPhone'));
        return
      }
      if (obj && !objParm.newPhone && isStateNum == 2) {
        this.$message.error(this.$t('app.pleaseEnterNewPhone'));
        return
      }
      if (obj && !objParm.phoneCode) {
        this.$message.error(this.$t('app.pleaseEnterVerifyCode'));
        return
      }
      if (isStateNum == 1) {
        let params = {
          phoneNo: phone,
          code: objParm.phoneCode
        }
        await checkValidCode(params).then(res => {
          if (res.code === 0) {
            this.isStateNum = 2;
            this.okText = this.$t('app.auto_63_c72e441b');
            this.layerTitle = this.$t('app.auto_64_b77421ef');
            this.objParm = {}
            this.handleClick()
          } else {
            message.warning(res.message || this.$t('app.auto_65_5b3129b0'))
          }
        })
      }
    },
    async ToLogin(params) {
      if (this.loading) {
        return false
      }
      this.loading = true;
      let loginRet = await toDoLogin({
        ...params
      }).catch(_ => {
        this.loading = false;
      })
      localStorage.removeItem(SSO_CAMPUS_INFO)
      localStorage.removeItem(SSO_LOGIN_INFO)
      localStorage.removeItem('sideMenuId')
      localStorage.removeItem('needBackSso')
      localStorage.removeItem('showAccountUpdateVisible')
      localStorage.removeItem('showBannerTips')
      localStorage.removeItem(ACCOUNT_UPGRADE)
      localStorage.removeItem(CRM_All_CALLCENTER); // 话务
      localStorage.removeItem(CRM_CALLCENTER_INFO); // 话务
      if (!loginRet || (loginRet.code !== 0)) {
        this.loading = false;
        this.$message.error(this.$getCodeMessage(loginRet.code, loginRet.message, loginRet.messageArgs) || this.$t('login.loginFailed'));
        return false
      } else {
        const { loginSsoCampusInfo, loginSsoInfo } = loginRet.data;
        localStorage.setItem(SSO_CAMPUS_INFO, JSON.stringify(loginSsoCampusInfo || []));
        if (loginSsoInfo) {
          const { dingTalkStatus } = loginSsoInfo; // | loginSsoInfo.dingTalkStatus | int | 钉钉绑定状态 0 正常 1 未绑定 2 未加入部门|
          if (dingTalkStatus == 1) {
            // 未绑定钉钉 跳转至账号中心进行绑定
            const accountCenterUrl = getBasicUrls().accountCenter; // 获取账号中心配置域名
            const url = accountCenterUrl + '/bind-dd';
            window.location.href = url;
            return
          }
        }
      }
      let token = (loginRet.data || {}).token,
        IsUpdatepwd = (loginRet.data || { isUpdatepwd: 0 }).user.isUpdatepwd,
        callCenterInfo = (loginRet.data || {}).callCenterInfo || []
      if (!token) {
        return false
      }

      localStorage.setItem('needBackSso', '1')

      // 登录成功后，保存用户信息
      const loginSsoInfo = (loginRet.data || {}).loginSsoInfo || null;
      LoginUserHelper.saveUserInfo({
        loginSsoInfo,
      });
      if (loginRet?.data?.user) {
        LoginUserHelper.updateUserInfo({ ...loginRet.data.user, token });
      }

      if (loginRet.data.phoneCheckInfo && loginRet.data.phoneCheckInfo.isPhoneCheck === 0) {
        this.loading = false;
        modal.openComponent(MobilePhoneVerification, {
          title: this.$t('app.auto_66_3d5ad168'),
          modalType: 'default',
          CancelButton: true,
          CancelButtonText: this.$t('app.auto_67_2240de22'),
          ConfirmButton: true,
          ConfirmButtonText: [{
            type: 'ConfirmButton',
            ButtonText: this.$t('app.auto_68_3c08da52')
          }],
          BindOrderList: loginRet.data.phoneCheckInfo,
          callback: (type, self) => {
            if (type == 'ConfirmButton') {
              self.submit && self.submit((res, close) => {
                if (res) {
                  close();
                  queryUserNavAndFunc().then(async ret => {
                    if (ret.code === 0) {
                      window.gio('track', ret.data.loginUserBaseInfo.id, "toDoLogin");
                      let loginNavList = ret.data.loginNavList.filter(item => {
                        return item.id !== 1144 && item.id !== 1436
                      })
                      let DefaultCallCenterInfo = callCenterInfo.filter(item => {
                        return item.isDefault
                      });
                      if (DefaultCallCenterInfo.length > 0) {
                        unlocking(Master_Use_Callphone, JSON.stringify(ret.data.loginFuncList)) && localStorage.setItem(CRM_CALLCENTER_INFO, JSON.stringify(DefaultCallCenterInfo[0]));
                      }
                      this.props.dispatch(SetCrmMenu(loginNavList))
                      loginNavList[0] && this.props.dispatch(SetSideMenu(loginNavList[0].childList))
                      localStorage.setItem(CRM_All_CALLCENTER, JSON.stringify(callCenterInfo)); // 用户信息
                      localStorage.setItem(CRM_FUNC_KEYS, JSON.stringify(ret.data.loginFuncList)); // 用户功能key
                      localStorage.setItem(CRM_NAVFUNC_KEYS, JSON.stringify(ret.data.loginNavFuncList)); // 菜单访问功能key
                      localStorage.setItem(CRM_MENU, JSON.stringify(loginNavList)); // 用户菜单
                      localStorage.setItem(SideBarMenu, JSON.stringify((loginNavList[0] || {}).childList || []))
                      let CrmNavIds = await this.getCrmNavIds(loginNavList)
                      localStorage.setItem(CRM_NAVFUNC_URLS, JSON.stringify(Object.keys(CrmNavIds.MenuKeys)))
                      localStorage.setItem(CRM_MENU_KEYS, JSON.stringify(CrmNavIds.MenuKeys))
                      localStorage.setItem(CRM_MENU_REPORT, JSON.stringify(CrmNavIds.reportList))
                      if (!!loginNavList[0] && loginNavList[0].childList && (loginNavList[0].childList.length > 0)) {
                        localStorage.setItem('OpenKeys', JSON.stringify(loginNavList[0] ? [loginNavList[0].id + ''] : []))
                        localStorage.setItem('SelectedKeys', JSON.stringify(loginNavList[0].childList[0] ? [loginNavList[0].childList[0].id + ''] : []))
                      } else {
                        localStorage.setItem('OpenKeys', JSON.stringify([]))
                        localStorage.setItem('SelectedKeys', JSON.stringify(loginNavList[0] ? [loginNavList[0].id + ''] : []))
                      }
                      localStorage.setItem('IsUpdatepwd', IsUpdatepwd)
                      if (getCookie('caseSource')) {
                        delCookie('caseSource')
                      }
                      this.props.history.replace('/')
                      this.getCampusIdentity()
                    } else {
                      this.setState({
                        loading: false
                      })
                      this.$message({
                        message: ret.message || this.$t('app.auto_69_b96f9f4f'),
                        type: 'warning'
                      });
                    }
                  }).catch(_ => {
                    this.setState({
                      loading: false
                    })
                  })
                  this.$store.dispatch('getsubjectdict',1)
                  this.$store.dispatch('getsubjectdict',2)
                } else {
                  close();
                }
              })
            }
          }
        })
      }
      else {
        queryUserNavAndFunc().then(async ret => {
          if (ret.code === 0) {
            window.gio('track', ret.data.loginUserBaseInfo.id, "toDoLogin");
            let loginNavList = ret.data.loginNavList.filter(item => {
              return item.id !== 1144 && item.id !== 1436
            })
            let DefaultCallCenterInfo = callCenterInfo.filter(item => {
              return item.isDefault
            });

            this.props.dispatch(SetCrmMenu(loginNavList))
            loginNavList[0] && this.props.dispatch(SetSideMenu(loginNavList[0].childList))
            localStorage.setItem(CRM_All_CALLCENTER, JSON.stringify(callCenterInfo)); // 用户信息
            localStorage.setItem(CRM_FUNC_KEYS, JSON.stringify(ret.data.loginFuncList)); // 用户功能key
            localStorage.setItem(CRM_NAVFUNC_KEYS, JSON.stringify(ret.data.loginNavFuncList)); // 菜单访问功能key
            localStorage.setItem(CRM_MENU, JSON.stringify(loginNavList)); // 用户菜单
            localStorage.setItem(SideBarMenu, JSON.stringify((loginNavList[0] || {}).childList || []));

            let CrmNavIds = await this.getCrmNavIds(loginNavList)
            localStorage.setItem(CRM_NAVFUNC_URLS, JSON.stringify(Object.keys(CrmNavIds.MenuKeys)))
            localStorage.setItem(CRM_MENU_KEYS, JSON.stringify(CrmNavIds.MenuKeys))
            localStorage.setItem(CRM_MENU_REPORT, JSON.stringify(CrmNavIds.reportList))
            if (!!loginNavList[0] && loginNavList[0].childList && (loginNavList[0].childList.length > 0)) {
              localStorage.setItem('OpenKeys', JSON.stringify(loginNavList[0] ? [loginNavList[0].id + ''] : []))
              localStorage.setItem('SelectedKeys', JSON.stringify(loginNavList[0].childList[0] ? [loginNavList[0].childList[0].id + ''] : []))
            } else {
              localStorage.setItem('OpenKeys', JSON.stringify([]))
              localStorage.setItem('SelectedKeys', JSON.stringify(loginNavList[0] ? [loginNavList[0].id + ''] : []))
            }
            localStorage.setItem('IsUpdatepwd', IsUpdatepwd)

            if (DefaultCallCenterInfo.length > 0) {
              unlocking(Master_Use_Callphone, JSON.stringify(ret.data.loginFuncList)) && localStorage.setItem(CRM_CALLCENTER_INFO, JSON.stringify(DefaultCallCenterInfo[0]));
            }

            if (getCookie('caseSource')) {
              delCookie('caseSource')
            }

            this.props.history.replace('/')

            this.getCampusIdentity()
          } else {
            this.loading = false;
            this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || this.$t('login.loginFailed'));
          }
        }).catch(_ => {
          this.setState({
            loading: false
          })
        })
        this.$store.dispatch('getsubjectdict',1)
        this.$store.dispatch('getsubjectdict',2)
      }
    },
    //获取当前用户所在校区身份
    getCampusIdentity() {
      getCampusIdentity({}).then(ret => {
        if (ret.code === 0) {
          localStorage.setItem(CRM_SCHOOL_TYPE, JSON.stringify(ret.data.identityCode));
        }
      })
    },

    getCrmNavIds(menu, MenuKeys = {}, reportList = []) {
      return new Promise(resolve => {
        if (menu && menu.length > 0) {
          for (let i = 0; i < menu.length; i++) {
            if (menu[i].childList && (menu[i].childList.length > 0)) {
              MenuKeys[menu[i].url.replace(/^(\S+)\?\S+$/, "$1")] = {
                openKeys: null,
                selectedKeys: menu[i].id
              }
              this.getCrmNavIds(menu[i].childList, MenuKeys, reportList).then(item => {
                resolve({
                  MenuKeys: {
                    ...MenuKeys,
                    ...item.MenuKeys,
                    path: menu[i].path,
                  },
                  reportList: [].concat(reportList, item.reportList || []),
                })
              })
            } else if (menu[i].url) {
              MenuKeys[menu[i].url.replace(/^(\S+)\?\S+$/, "$1")] = {
                selectedKeys: menu[i].id,
                path: menu[i].path,
                isLimit: menu[i].isLimit,
              }
              resolve({
                MenuKeys,
                reportList
              })
            }

          }
        } else {
          resolve({
            MenuKeys: {},
            reportList: [],
          })
        }
      })
    }
  },
}
</script>

<style></style>